import { combineReducers } from "@reduxjs/toolkit";
import toggle from "./toggleSlice";

const appReducers = combineReducers({
  toggle,
});

export default appReducers;
